/* unplugin-vue-components disabled */import { render } from "./reviewee.vue?vue&type=template&id=0f019a89&scoped=true&ts=true"
import script from "./reviewee.vue?vue&type=script&lang=ts"
export * from "./reviewee.vue?vue&type=script&lang=ts"

import "./reviewee.vue?vue&type=style&index=0&id=0f019a89&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f019a89"]])

export default __exports__